import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import Breadcrumbs, { BreadcrumbsItem } from '../../../template/MainTheme/components/Breadcrumbs';
import { AppContext } from '../../../contexts/AppContext';
import useNavigationPage from '../../../hooks/useNavigationPage';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { SectorDataForm, SectorFilters } from '../../../app/models/Sector';
import useSectorService from '../../../app/services/hooks/useSectorService';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import DefaultCard from '../../../components/default/DefaultCard';
import DefaultToolBar from '../../../components/default/DefaultToolBar';
import ButtonCreate from '../../../components/buttons/ButtonCreate';
import SectorDataTable from './tables/SectorDataTable';
import DefaultModal from '../../../components/default/DefaultModal';
import SectorCreate from './SectorCreate';
import SectorEdit from './SectorEdit';




const breadcrumbs: BreadcrumbsItem[] = [
    { name: 'Sectores', url: '/sectors', isActive: true }
];

const Sectors = () => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const { navigationPage } = useNavigationPage();
    const confirmAlert = useReactConfirmAlert();

    const { fetchingGetSectors, getSectors, deleteSector, activeSector } = useSectorService();

    const [sectors, setSectors] = useState<SectorDataForm[]>([]);
    // const [sectorBusinessRulesEnum, setSectorBusinessRulesEnum] = useState<SectorBusinessRulesEnum[]>([]);
    const [sectorIdEdit, setSectorIdEdit] = useState<number>(-1);
    const [showingEdit, setShowingEdit] = useState(false);
    const [showingCreate, setShowingCreate] = useState(false);
    const [totalRows, setTotalRows] = useState<number>(0);
    const [sectorsFilter, setSectorsFilter] = useState<SectorFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'asc'
    });

    useEffect(() => {
        reloadTable();
    }, [sectorsFilter]);

    const reloadTable = () => {
        getSectors(sectorsFilter, {
            onSuccess: (response: ServiceResponse) => {
                setSectors(response.data.sectors);
                // setSectorBusinessRulesEnum(response.data.sector_business_rules_enum)
                setTotalRows(response.data.total_rows);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
                if (response.data?.to_dashboard) navigationPage('/');
            }
        });
    };

    const showEdit = (id: number) => {
        setSectorIdEdit(id);
        setShowingEdit(true);
    };

    const hideEdit = () => {
        setSectorIdEdit(-1);
        setShowingEdit(false);
    };

    const showCreate = () => setShowingCreate(true);
    const hideCreate = () => setShowingCreate(false);

    const destroy = (id: number) => {
        confirmAlert.requestConfirmation({
            title: '¿Estás seguro?',
            message: `Está a punto de eliminar el sector #${id}`,
            buttons: {
                confirmButton: {
                    label: 'Sí, confirmar',
                    onClick: () => {
                        showLoading?.('loading', 'Eliminando sector...');
                        deleteSector(id, {
                            onSuccess: (res) => {
                                hideLoading?.();
                                confirmAlert.successAlert({ title: 'Éxito', message: res.message });
                                reloadTable();
                            },
                            onError: (res) => {
                                hideLoading?.();
                                confirmAlert.errorAlert({ title: 'Error', message: res.message });
                            }
                        });
                    }
                },
                cancelButton: {
                    label: 'No, cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            confirmAlert.infoAlert({
                                title: 'Cancelado',
                                message: 'El sector no se ha eliminado.'
                            });
                        }, 0);
                    }
                }
            }
        });
    };

    const active = (id: number, active: boolean) => {
        activeSector(id, active, {
            onSuccess: (res) => {
                hideLoading?.();
                confirmAlert.successAlert({ title: 'Éxito', message: res.message });
                reloadTable();
            },
            onError: (res) => {
                hideLoading?.();
                confirmAlert.errorAlert({ title: 'Error', message: res.message });
            }
        });
    };

    return (
        <>

                <DefaultToolBar
                        left={<ButtonCreate callbackCreate={showCreate} title="Nuevo sector" />}
                />

                <SectorDataTable
                    sectors={sectors}
                    edit={showEdit}
                    destroy={destroy}
                    active={active}
                    loading={fetchingGetSectors}
                    filter={sectorsFilter}
                    setFilter={setSectorsFilter}
                    totalRows={totalRows}
                    callbackSuccess={reloadTable}
                />

            {showingCreate && (
                <DefaultModal
                    show={showingCreate}
                    handleClose={hideCreate}
                    title="Crear sector"
                    backdrop={true}
                    showFooter={false}
                >
                    <SectorCreate
                        onSaved={() => {
                            reloadTable();
                            hideCreate();
                        }}
                        onCancel={hideCreate}
                        onError={hideCreate}
                    />
                </DefaultModal>
            )}

            {showingEdit && (
                <DefaultModal
                    show={showingEdit}
                    handleClose={hideEdit}
                    title="Editar sector"
                    backdrop={true}
                    showFooter={false}
                >
                    <SectorEdit
                        sectorId={sectorIdEdit}
                        onSaved={() => {
                            reloadTable();
                            hideEdit();
                        }}
                        onCancel={hideEdit}
                        onError={hideEdit}
                    />
                </DefaultModal>
            )}
        </>
    );
};

export default Sectors;
